import { getId } from '../selectors/referential';

export const updateColumnSelection = (state, { payload = {} } = {}) => {
  const { referential, selected } = payload;
  return state.setIn(['columnMap', getId(referential)], selected);
};
